<template>
    <div v-if="sapProfile==true" style="overflow-x:auto !important">
        <div>
            <div style="overflow:auto">
                <div v-if="kid!=null" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr;padding: 5px">
                    <div class="my_font-weight_600">{{$t('3452')}}:</div>
                    <div>{{kid}}</div>
                    <div></div>
                </div>
                <hr v-if="kid!=null" />
                <div class="my_color_00338e my_fontWeight_600 my_fontSize_1Point5 ZAfont_family">{{$t('1098')}}</div>
                <!--<div style="display: grid; grid-template-columns: 2fr 1fr;">
                <div>-->
                <div style="display: grid; grid-template-columns: 2fr 1fr; grid-column-gap: 10px; margin-top:20px">
                    <div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size"></div>
                            </div>
                            <div class="ZAfont_family ZAfont_size" style="display: grid; margin-bottom: 10px">
                                <div>
                                    <input type="checkbox" v-model="SM250_TS280" />
                                    <span style="margin-left:10px">SM250 TS280</span>
                                </div>
                            </div>
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('3455')}}:</div>
                            </div>
                            <div v-if="certificationSelection.length==0 || certificationSelection.length>4">
                                <select v-model="selectedCertification" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: selectedCertification==null, my_input_background_color_at_validInput:selectedCertification!=null}">
                                    <option value="null" hidden>{{$t('3174')}}</option>
                                    <option value="" hidden>{{$t('3174')}}</option>
                                    <option v-for="certification in certificationSelection" v-bind:value="certification">
                                        {{certification.text.useTextKey?$t(certification.text.textKey):certification.text.textUI}}
                                    </option>
                                </select>
                            </div>
                            <div v-if="certificationSelection.length>0 && certificationSelection.length<=4">
                                <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selectedCertification==null, my_input_background_color_at_validInput:selectedCertification!=null}">
                                    <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                        <li v-for="certification in certificationSelection">
                                            <input type="checkbox" @input="change_Selected_atElementOf_certification(certification)" v-bind:checked="certification.selected" v-bind:disabled="certification.selected" />
                                            <span style="margin-left:10px">{{certification.text.useTextKey?$t(certification.text.textKey):certification.text.textUI}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('3456')}}:</div>
                            </div>
                            <div v-if="preferenceSelection.length==0 || preferenceSelection.length>4">
                                <select v-model="selectedPreference" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: selectedCertification==null, my_input_background_color_at_validInput:selectedPreference!=null}">
                                    <option value="null" hidden>{{$t('3174')}}</option>
                                    <option value="" hidden>{{$t('3174')}}</option>
                                    <option v-for="preference in preferenceSelection" v-bind:value="preference">
                                        {{preference.text.useTextKey?$t(preference.text.textKey):preference.text.textUI}}
                                    </option>
                                </select>
                            </div>
                            <div v-if="preferenceSelection.length>0 && preferenceSelection.length<=4">
                                <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selectedCertification==null, my_input_background_color_at_validInput:selectedPreference!=null}">
                                    <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                        <li v-for="preference in preferenceSelection">
                                            <input type="checkbox" @input="change_Selected_atElementOf_preference(preference)" v-bind:checked="preference.selected" v-bind:disabled="preference.selected" />
                                            <span style="margin-left:10px">{{preference.text.useTextKey?$t(preference.text.textKey):preference.text.textUI}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('3067')}}:</div>
                            </div>
                            <div v-if="temperatureMonitoringSelection.length==0 || temperatureMonitoringSelection.length>4">
                                <select v-model="selectedTemperatureMonitoring" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: selectedTemperatureMonitoring==null, my_input_background_color_at_validInput:selectedTemperatureMonitoring!=null}">
                                    <option value="null" hidden>{{$t('3174')}}</option>
                                    <option value="" hidden>{{$t('3174')}}</option>
                                    <option v-for="temperatureMonitoring in temperatureMonitoringSelection" v-bind:value="temperatureMonitoring.text">{{temperatureMonitoring.text}}</option>
                                </select>
                            </div>
                            <div v-if="temperatureMonitoringSelection.length>0 && temperatureMonitoringSelection.length<=4">
                                <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selectedTemperatureMonitoring==null, my_input_background_color_at_validInput:selectedTemperatureMonitoring!=null}">
                                    <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                        <li v-for="temperatureMonitoring in temperatureMonitoringSelection">
                                            <input type="checkbox" @input="change_Selected_atElementOf_temperatureMonitoring(temperatureMonitoring)" v-bind:checked="temperatureMonitoring.selected" v-bind:disabled="temperatureMonitoring.selected" />
                                            <span style="margin-left:10px">{{temperatureMonitoring.text}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 30px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('407')}}:</div>
                            </div>
                            <div v-if="motorTypeSelectionLength==0 || motorTypeSelectionLength>4">
                                <select v-model="selectedMotorType" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: selectedMotorType==null, my_input_background_color_at_validInput:selectedMotorType!=null}">
                                    <option value="null" hidden>{{$t('3174')}}</option>
                                    <option value="" hidden>{{$t('3174')}}</option>
                                    <option v-for="motorType in motorTypeSelection" v-bind:value="motorType">
                                        {{motorType.text.useTextKey?$t(motorType.text.textKey):motorType.text.textUI}}
                                    </option>
                                </select>
                            </div>
                            <div v-if="motorTypeSelectionLength>0 && motorTypeSelectionLength<=4">
                                <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selectedMotorType==null, my_input_background_color_at_validInput:selectedMotorType!=null}">
                                    <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                        <li v-for="motorType in motorTypeSelection">
                                            <input type="checkbox" @input="change_Selected_atElementOf_motorType(motorType)" v-bind:checked="motorType.selected" v-bind:disabled="motorType.selected" />
                                            <span style="margin-left:10px">{{motorType.text.useTextKey?$t(motorType.text.textKey):motorType.text.textUI}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('3453')}}:</div>
                            </div>
                            <div v-if="motorSizeSelectionLength==0 || motorSizeSelectionLength>4">
                                <select v-model="selectedMotorSize" class="my_select" style="width:100%" v-bind:disabled="selectedMotorType==null || selectedMotorType.text.text==null" v-bind:class="{my_input_border_at_invalidInput: selectedMotorSize==null, my_input_background_color_at_validInput:selectedMotorSize!=null}">
                                    <option value="null" hidden>{{$t('3174')}}</option>
                                    <option value="" hidden>{{$t('3174')}}</option>
                                    <option v-for="motorSize in motorSizeSelection" v-bind:value="motorSize" v-if="motorSize.disabled==false">
                                        {{motorSize.text.useTextKey?$t(motorSize.text.textKey):motorSize.text.textUI}}
                                    </option>
                                </select>
                            </div>
                            <div v-if="motorSizeSelectionLength>0 && motorSizeSelectionLength<=4">
                                <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selectedMotorSize==null, my_input_background_color_at_validInput:selectedMotorSize!=null}">
                                    <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                        <li v-for="motorSize in motorSizeSelection" v-if="motorSize.disabled==false">
                                            <input type="checkbox" @input="change_Selected_atElementOf_motorSize(motorSize)" v-bind:checked="motorSize.selected" v-bind:disabled="motorSize.selected" />
                                            <span style="margin-left:10px">{{motorSize.text.useTextKey?$t(motorSize.text.textKey):motorSize.text.textUI}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('3454')}}:</div>
                            </div>
                            <div v-if="motorPackageSelectionLength==0 || motorPackageSelectionLength>4">
                                <select v-model="selectedMotorPackage" class="my_select" style="width:100%" v-bind:disabled="selectedMotorSize==null || selectedMotorSize.text.text==null" v-bind:class="{my_input_border_at_invalidInput: selectedMotorPackage==null, my_input_background_color_at_validInput:selectedMotorPackage!=null}">
                                    <option value="null" hidden>{{$t('3174')}}</option>
                                    <option value="" hidden>{{$t('3174')}}</option>
                                    <option v-for="motorPackage in motorPackageSelection" v-bind:value="motorPackage" v-if="motorPackage.disabled==false">
                                        {{motorPackage.text.useTextKey?$t(motorPackage.text.textKey):motorPackage.text.textUI}}
                                    </option>
                                </select>
                            </div>
                            <div v-if="motorPackageSelectionLength>0 && motorPackageSelectionLength<=4">
                                <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selectedMotorPackage==null, my_input_background_color_at_validInput:selectedMotorPackage!=null}">
                                    <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                        <li v-for="motorPackage in motorPackageSelection" v-if="motorPackage.disabled==false">
                                            <input type="checkbox" @input="change_Selected_atElementOf_motorPackage(motorPackage)" v-bind:checked="motorPackage.selected" v-bind:disabled="motorPackage.selected" />
                                            <span style="margin-left:10px">{{motorPackage.text.useTextKey?$t(motorPackage.text.textKey):motorPackage.text.textUI}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div v-if="motorZusatzSelection!=null" style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">Zusatz:</div>
                            </div>
                            <div v-if="motorZusatzSelectionLength==0 || motorZusatzSelectionLength>4">
                                <select v-model="selectedMotorZusatz" class="my_select" style="width:100%" v-bind:disabled="selectedMotorPackage==null || selectedMotorPackage.text.text==null" v-bind:class="{my_input_border_at_invalidInput: motorZusatzSelection.length > 0 && selectedMotorPackage==null, my_input_background_color_at_validInput: motorZusatzSelection.length == 0 || selectedMotorPackage!=null}">
                                    <option value="null" hidden>{{$t('3174')}}</option>
                                    <option value="" hidden>{{$t('3174')}}</option>
                                    <option v-for="motorZusatz in motorZusatzSelection" v-bind:value="motorZusatz" v-if="motorZusatz.disabled==false">
                                        {{motorZusatz.text.useTextKey?$t(motorZusatz.text.textKey):motorZusatz.text.textUI}}
                                    </option>
                                </select>
                            </div>
                            <div v-if="motorZusatzSelectionLength>0 && motorZusatzSelectionLength<=4">
                                <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput:motorZusatzSelectionLength > 0 && selectedMotorPackage==null, my_input_background_color_at_validInput: motorZusatzSelectionLength == 0 || selectedMotorPackage!=null}">
                                    <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                        <li v-for="motorZusatz in motorZusatzSelection" v-if="motorZusatz.disabled==false">
                                            <input type="checkbox" @input="change_Selected_atElementOf_motorZusatz(motorZusatz)" v-bind:checked="motorZusatz.selected" v-bind:disabled="motorZusatz.selected && motorZusatzNecessary==true" />
                                            <span style="margin-left:10px">{{motorZusatz.text.useTextKey?$t(motorZusatz.text.textKey):motorZusatz.text.textUI}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('121')}}:</div>
                            </div>
                            <div v-if="motorVoltageSelectionLength==0 || motorVoltageSelectionLength>4">
                                <div class="my_input-group">
                                    <select v-model="selectedMotorVoltage" class="my_select" style="width:100%" v-bind:disabled="((selectedMotorPackage==null || selectedMotorPackage.text.text==null)) || (motorZusatzSelection!=null && (selectedMotorZusatz==null || selectedMotorZusatz.text.text==null) && motorZusatzNecessary==true)" v-bind:class="{my_input_border_at_invalidInput: selectedMotorVoltage==null, my_input_background_color_at_validInput:selectedMotorVoltage!=null}">
                                        <option value="null" hidden>{{$t('3174')}}</option>
                                        <option value="" hidden>{{$t('3174')}}</option>
                                        <option v-for="motorVoltage in motorVoltageSelection" v-bind:value="motorVoltage" v-if="motorVoltage.disabled==false">{{motorVoltage.value}}</option>
                                    </select>
                                    <div class="my_input-group_unit ZAfont_family" style="width:auto;max-width:60px">V</div>
                                </div>
                            </div>
                            <div v-if="motorVoltageSelectionLength>0 && motorVoltageSelectionLength<=4">
                                <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selectedMotorVoltage==null, my_input_background_color_at_validInput:selectedMotorVoltage!=null}">
                                    <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                        <li v-for="motorVoltage in motorVoltageSelection" v-if="motorVoltage.disabled==false">
                                            <input type="checkbox" @input="change_Selected_atElementOf_motorVoltage(motorVoltage)" v-bind:checked="motorVoltage.selected" v-bind:disabled="motorVoltage.selected" />
                                            <span style="margin-left:10px">{{motorVoltage.value}} V</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('1091')}} | {{$t('1090')}}:</div>
                            </div>
                            <div v-if="motorRatedSpeedSelectionLength==0 || motorRatedSpeedSelectionLength>4">
                                <select v-model="selectedMotorRatedSpeed" class="my_select" style="width:100%" v-bind:disabled="selectedMotorVoltage==null || selectedMotorVoltage.value==null" v-bind:class="{my_input_border_at_invalidInput: selectedMotorRatedSpeed==null, my_input_background_color_at_validInput:selectedMotorRatedSpeed!=null}">
                                    <option value="null" hidden>{{$t('3174')}}</option>
                                    <option value="" hidden>{{$t('3174')}}</option>
                                    <option v-for="motorRatedSpeed in motorRatedSpeedSelection" v-bind:value="motorRatedSpeed" v-if="motorRatedSpeed.disabled==false">{{motorRatedSpeed.value}} rpm | {{motorRatedSpeed.pr}} kw</option>
                                </select>
                            </div>
                            <div v-if="motorRatedSpeedSelectionLength>0 && motorRatedSpeedSelectionLength<=4">
                                <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selectedMotorRatedSpeed==null, my_input_background_color_at_validInput:selectedMotorRatedSpeed!=null}">
                                    <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                        <li v-for="motorRatedSpeed in motorRatedSpeedSelection" v-if="motorRatedSpeed.disabled==false">
                                            <input type="checkbox" @input="change_Selected_atElementOf_motorRatedSpeed(motorRatedSpeed)" v-bind:checked="motorRatedSpeed.selected" v-bind:disabled="motorRatedSpeed.selected" />
                                            <span style="margin-left:10px">{{motorRatedSpeed.value}} rpm | {{motorRatedSpeed.pr}} kw</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                                <div>
                                    <div class="ZAfont_family ZAfont_size">{{$t('3457')}}:</div>
                                </div>
                                <div v-if="motorIpSelection.length==0 || motorIpSelection.length>4">
                                    <select v-model="selectedMotorIp" class="my_select" style="width:100%" v-bind:disabled="selectedMotorVoltage==null || selectedMotorVoltage.value==null" v-bind:class="{my_input_border_at_invalidInput: selectedMotorIp==null, my_input_background_color_at_validInput:selectedMotorIp!=null}">
                                        <option value="null" hidden>{{$t('3174')}}</option>
                                        <option value="" hidden>{{$t('3174')}}</option>
                                        <option v-for="motorIp in motorIpSelection" v-bind:value="motorIp.text">{{motorIp.text}}</option>
                                    </select>
                                </div>
                                <div v-if="motorIpSelection.length>0 && motorIpSelection.length<=4" style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selectedMotorIp==null, my_input_background_color_at_validInput:selectedMotorIp!=null}">
                                    <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                        <li v-for="motorIp in motorIpSelection" v-if="motorIp.display!=null && motorIp.display==true">
                                            <input type="checkbox" @input="change_Selected_atElementOf_motorIpSelection(motorIp)" v-bind:checked="motorIp.selected" v-bind:disabled="motorIp.selected" />
                                            <span style="margin-left:10px">{{motorIp.text}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('298')}}:</div>
                            </div>
                            <div v-if="forcedVentilationSelection.length==0 && forcedVentilationSelection.length>4">
                                <select v-model="selectedForcedVentilation" class="my_select" style="width:100%" v-bind:disabled="selectedMotorVoltage==null || selectedMotorVoltage.value==null" v-bind:class="{my_input_border_at_invalidInput: selectedForcedVentilation==null, my_input_background_color_at_validInput:selectedForcedVentilation!=null}">
                                    <option value="null" hidden>{{$t('3174')}}</option>
                                    <option value="" hidden>{{$t('3174')}}</option>
                                    <option v-for="forcedVentilation in forcedVentilationSelection" v-bind:value="forcedVentilation">
                                        {{forcedVentilation.text.useTextKey?$t(forcedVentilation.text.textKey):forcedVentilation.text.textUI}}
                                    </option>
                                </select>
                            </div>
                            <div v-if="forcedVentilationSelection.length>0 && forcedVentilationSelection.length<=4">
                                <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selectedForcedVentilation==null, my_input_background_color_at_validInput:selectedForcedVentilation!=null}">
                                    <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                        <li v-for="forcedVentilation in forcedVentilationSelection">
                                            <input type="checkbox" @input="change_Selected_atElementOf_forcedVentilation(forcedVentilation)" v-bind:checked="forcedVentilation.selected" v-bind:disabled="forcedVentilation.selected" />
                                            <span style="margin-left:10px">{{forcedVentilation.text.useTextKey?$t(forcedVentilation.text.textKey):forcedVentilation.text.textUI}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div v-if="selectedForcedVentilationWithBrakeRelease!=null" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>{{$t('3553')}}</div>
                            <div>
                                <div>
                                    <span>{{selectedForcedVentilationWithBrakeRelease.useTextKey?$t(selectedForcedVentilationWithBrakeRelease.textKey):selectedForcedVentilationWithBrakeRelease.textUI}} </span>
                                </div>
                            </div>
                        </div>
                        <div v-if="selectedMotorId!=null" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>{{$t('3427')}}</div>
                            <div>
                                <div>
                                    <span>{{selectedMotorId}}</span>
                                    <span v-if="motorSelection!=null&&motorSelection.length>1" style="margin-left:10px; margin-bottom:0px; text-align:left">
                                        <a @click.prevent="showModalInputSelection" class="ZAfont_family ZAfont_size" href="#">{{$t('3182')}}</a>
                                    </span>
                                </div>
                            </div>
                        </div>
                        
                        <!--<div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
        <div class="ZAfont_family ZAfont_size">
            <div>{{$t('3049')}} 1:</div>
        </div>
        <div>
            <input class="form-control" v-bind:placeholder="this.$i18n.i18next.t('3173')" v-model="operatingCurrentSplus" v-bind:disabled="customerName!='S+'" />
        </div>
    </div>-->
                        <!--</div>-->
                        <!--<div style="margin-left:50px">
            <iframe src="https://za.io/products/drive-technology/zatop-sm315" style="height:500px;width:500px"></iframe>
            <div>
                <a href="https://za.io/products/drive-technology/zatop-sm315" target="_blank">ZAtop SM315</a>
            </div>
        </div>
    </div>-->
                    </div>
                    <div style="display:flex; justify-content: center; align-items: center">
                        <div v-if="motorImagePath!=null">
                            <Images :imageFilePath="motorImagePath" :maxImageHeight="250" :maxImageWidth="250"></Images>
                        </div>
                    </div>
                </div>
                <hr />
            </div>
            <TractionSheaveModal v-if="showTractionSheave==true"></TractionSheaveModal>
            <RopeGuardModal v-if="showRopeGuard==true"></RopeGuardModal>
            <InputSelectionModal v-if="showInputSelectionModal==true" :version="'zlm'"></InputSelectionModal>
            <div class="my_btn_nextConfigurationStep_position">
                <button @click="furtherToManualHome()" class="btn my_btn_nextConfigurationStep" style="margin-right: 5px">{{$t('3366')}}</button>
                <button @click="furtherToDriveTechnologies()" class="btn my_btn_nextConfigurationStep">{{$t('1023')}}</button>
            </div>
        </div>
    </div>
</template>


<script>
    import router from '../../../router';
    import { configurations } from '../../../store/configurations.module';
    import { tractionSheaveManual } from '../../../store/tractionSheaveManual.module'
    import { ropeGuardManual } from '../../../store/ropeGuardManual.module'
    import InvalidityReasons from '../../dataValidation/InvalidityReasons';
    import LoaderIcon from '../../loader/LoaderIcon';
    import axios from 'axios';
    import Images from '../../configuration/Images';
    import TractionSheaveModal from '../../configuration/manualSteps/TractionSheaveModal';
    import RopeGuardModal from '../../configuration/manualSteps/RopeGuardModal';
    import InputSelectionModal from '../../configuration/manualSteps/InputSelectionModal';
    export default {
        name: 'InputsManual',

        components: {
            InvalidityReasons,
            LoaderIcon,
            Images,
            TractionSheaveModal,
            RopeGuardModal,
            InputSelectionModal,
        },

        data() {
            return {
                accept_terms_of_request: false,
            }
        },

        computed: {
            sapProfile: {
                get() {
                    return this.$store.state.configurations.sap;
                },
            },
            kid: {
                get() {
                    return this.$store.state.manualHome.kid;
                },
            },
            showTractionSheave: {
                get() {
                    if (this.selectedMotorRatedSpeed != null) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
            },
            showRopeGuard: {
                get() {
                    if (this.$store.state.tractionSheaveManual.sheaveProfileSelection != null && Array.isArray(this.$store.state.tractionSheaveManual.sheaveProfileSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.tractionSheaveManual.sheaveProfileSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return true
                        }
                    }
                    if (this.$store.state.tractionSheaveManual.deliverTractionSheaveSelection != null && Array.isArray(this.$store.state.tractionSheaveManual.deliverTractionSheaveSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.tractionSheaveManual.deliverTractionSheaveSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1 && this.$store.state.tractionSheaveManual.deliverTractionSheaveSelection[firstIndex_whichMeetConditions].text.code == 0) {
                            return true
                        }
                    }
                    return false
                }
            },
            motorSelection: {
                get() {
                    return this.$store.state.inputsManual.motordetailsSelection;
                }
            },
            selectedMotorId: {
                get() {
                    if (this.$store.state.inputsManual.motordetailsSelection != null && this.$store.state.inputsManual.motordetailsSelection.length > 0) {
                        const firstIndex_whichMeetConditions = this.$store.state.inputsManual.motordetailsSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.inputsManual.motordetailsSelection[firstIndex_whichMeetConditions].id;
                        }

                    }
                    return null;
                }
            },
            showInputSelectionModal: {
                get() {
                    return this.$store.state.inputsManual.showInputSelectionModal;
                }
            },
            // Preselection motor
            motorTypeSelection: {
                get() {
                    return this.$store.state.inputsManual.motorTypeSelection;
                },
            },
            motorSizeSelection: {
                get() {
                    return this.$store.state.inputsManual.motorSizeSelection;
                },
            },
            motorPackageSelection: {
                get() {
                    return this.$store.state.inputsManual.motorPackageSelection;
                },
            },
            motorZusatzSelection: {
                get() {
                    if (this.$store.state.inputsManual.motorZusatzSelection != null && Array.isArray(this.$store.state.inputsManual.motorZusatzSelection)) {
                        let motorZusatz_Selection = this.$store.state.inputsManual.motorZusatzSelection.filter((x) => { return (x.disabled == false && x.text.text != null) });
                        if (motorZusatz_Selection != null && motorZusatz_Selection.length > 0) {
                            return motorZusatz_Selection;
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                },
            },
            motorZusatzNecessary: {
                get() {
                    if (this.$store.state.inputsManual.motorZusatzSelection != null && Array.isArray(this.$store.state.inputsManual.motorZusatzSelection)) {
                        let motorZusatz_Selection = this.$store.state.inputsManual.motorZusatzSelection.filter((x) => { return (x.disabled == false) });
                        if (motorZusatz_Selection != null && motorZusatz_Selection.length > 0) {
                            const firstIndex_whichMeetConditions = motorZusatz_Selection.findIndex(i => (i.text.text == null));
                            if (firstIndex_whichMeetConditions > -1) {
                                return false;
                            }
                            else {
                                return true;
                            }
                        }
                        else {
                            return false;
                        }
                    }
                    else {
                        return false;
                    }
                },
            },
            motorVoltageSelection: {
                get() {
                    return this.$store.state.inputsManual.motorVoltageSelection;
                },
            },
            motorRatedSpeedSelection: {
                get() {
                    return this.$store.state.inputsManual.motorRatedSpeedSelection;
                },
            },
            certificationSelection: {
                get() {
                    return this.$store.state.inputsManual.certificationSelection;
                },
            },
            preferenceSelection: {
                get() {
                    return this.$store.state.inputsManual.preferenceSelection;
                },
            },
            temperatureMonitoringSelection: {
                get() {
                    return this.$store.state.inputsManual.temperatureMonitoringSelection;
                },
            },
            forcedVentilationSelection: {
                get() {
                    return this.$store.state.inputsManual.forcedVentilationSelection;
                },
            },
            motorIpSelection: {
                get() {
                    return this.$store.state.inputsManual.motorIpSelection;
                },
            },
            customerName: {
                get() {
                    return this.$store.state.manualHome.kid;
                },
            },
            motorTypeSelectionLength: {
                get() {
                    if (this.$store.state.inputsManual.motorTypeSelection != null && Array.isArray(this.$store.state.inputsManual.motorTypeSelection)) {
                        let length = this.$store.state.inputsManual.motorTypeSelection.filter((x) => { return (x.disabled == false) }).length;
                        if (length != null && length > 0) {
                            return length;
                        }
                        else {
                            return 0;
                        }
                    }
                    else {
                        return 0;
                    }
                }
            },
            motorSizeSelectionLength: {
                get() {
                    if (this.$store.state.inputsManual.motorSizeSelection != null && Array.isArray(this.$store.state.inputsManual.motorSizeSelection)) {
                        let length = this.$store.state.inputsManual.motorSizeSelection.filter((x) => { return (x.disabled == false) }).length;
                        if (length != null && length > 0) {
                            return length;
                        }
                        else {
                            return 0;
                        }
                    }
                    else {
                        return 0;
                    }
                }
            },
            motorPackageSelectionLength: {
                get() {
                    if (this.$store.state.inputsManual.motorPackageSelection != null && Array.isArray(this.$store.state.inputsManual.motorPackageSelection)) {
                        let length = this.$store.state.inputsManual.motorPackageSelection.filter((x) => { return (x.disabled == false) }).length;
                        if (length != null && length > 0) {
                            return length;
                        }
                        else {
                            return 0;
                        }
                    }
                    else {
                        return 0;
                    }
                }
            },
            motorZusatzSelectionLength: {
                get() {
                    if (this.$store.state.inputsManual.motorZusatzSelection != null && Array.isArray(this.$store.state.inputsManual.motorZusatzSelection)) {
                        let length = this.$store.state.inputsManual.motorZusatzSelection.filter((x) => { return (x.disabled == false) }).length;
                        if (length != null && length > 0) {
                            return length;
                        }
                        else {
                            return 0;
                        }
                    }
                    else {
                        return 0;
                    }
                }
            },
            motorVoltageSelectionLength: {
                get() {
                    if (this.$store.state.inputsManual.motorVoltageSelection != null && Array.isArray(this.$store.state.inputsManual.motorVoltageSelection)) {
                        let length = this.$store.state.inputsManual.motorVoltageSelection.filter((x) => { return (x.disabled == false) }).length;
                        if (length != null && length > 0) {
                            return length;
                        }
                        else {
                            return 0;
                        }
                    }
                    else {
                        return 0;
                    }
                }
            },
            motorRatedSpeedSelectionLength: {
                get() {
                    if (this.$store.state.inputsManual.motorRatedSpedSelection != null && Array.isArray(this.$store.state.inputsManual.motorRatedSpedSelection)) {
                        let length = this.$store.state.inputsManual.motorRatedSpedSelection.filter((x) => { return (x.disabled == false) }).length;
                        if (length != null && length > 0) {
                            return length;
                        }
                        else {
                            return 0;
                        }
                    }
                    else {
                        return 0;
                    }
                }
            },
            selectedMotorType: {
                get() {
                    return this.$store.getters['inputsManual/motorType'];
                },
                set(value) {
                    this.change_Selected_atElementOf_motorType(value);
                }
            },
            selectedMotorSize: {
                get() {
                    return this.$store.getters['inputsManual/motorSize'];
                },
                set(value) {
                    this.change_Selected_atElementOf_motorSize(value);
                }
            },
            selectedMotorPackage: {
                get() {
                    return this.$store.getters['inputsManual/motorPackage'];
                },
                set(value) {
                    this.change_Selected_atElementOf_motorPackage(value);
                }
            },
            selectedMotorZusatz: {
                get() {
                    return this.$store.getters['inputsManual/motorZusatz'];
                },
                set(value) {
                    this.change_Selected_atElementOf_motorZusatz(value);
                }
            },
            selectedMotorVoltage: {
                get() {
                    return this.$store.getters['inputsManual/motorVoltage'];
                },
                set(value) {
                    this.change_Selected_atElementOf_motorVoltage(value);
                }
            },
            selectedMotorRatedSpeed: {
                get() {
                    return this.$store.getters['inputsManual/motorRatedSpeed'];
                },
                set(value) {
                    this.change_Selected_atElementOf_motorRatedSpeed(value);
                }
            },
            selectedCertification: {
                get() {
                    return this.$store.getters['inputsManual/certification'];
                },
                set(value) {
                    this.change_Selected_atElementOf_certification(value);
                }
            },
            selectedPreference: {
                get() {
                    return this.$store.getters['inputsManual/preference'];
                },
                set(value) {
                    this.change_Selected_atElementOf_preference(value);
                }
            },
            selectedTemperatureMonitoring: {
                get() {
                    return this.$store.getters['inputsManual/MSART'];
                },
                set(value) {
                    this.change_Selected_atElementOf_temperatureMonitoring(value);
                }
            },
            selectedMotorIp: {
                get() {
                    if (this.$store.state.inputsManual.motorIpSelection != null && Array.isArray(this.$store.state.inputsManual.motorIpSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.inputsManual.motorIpSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.inputsManual.motorIpSelection[firstIndex_whichMeetConditions].text;
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                },
                set(value) {
                    this.change_Selected_atElementOf_motorIpSelection(value);
                }
            },
            selectedForcedVentilation: {
                get() {
                    return this.$store.getters['inputsManual/forcedVentilation'];
                },
                set(value) {
                    this.change_Selected_atElementOf_forcedVentilation(value);
                }
            },
            selectedForcedVentilationWithBrakeRelease: {
                get() {
                    if (this.$store.state.inputsManual.forcedVentilationSelection != null && Array.isArray(this.$store.state.inputsManual.forcedVentilationSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.inputsManual.forcedVentilationSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.inputsManual.forcedVentilationSelection[firstIndex_whichMeetConditions].canBeCombinedWithBrakeRelease;
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        return null;
                    }
                },
            },

            motorImagePath: {
                get() {
                    return this.$store.getters['inputsManual/motorImagePath'];
                }
            },

            SM250_TS280: {
                get() {
                    return this.$store.state.inputsManual.sM250_TS280;
                },
                set(value) {
                    this.change_Selected_SM250_TS280(value);
                }
            },
            statusModal_Shown: {
                get() {
                    return this.$store.state.statusHandling.statusModal_Shown;
                },
            },
        },

        created() {
            //this.$store.commit('manualHome/change_kid_storeMutation', this.$store.state.manualHome.kid)
            this.$store.commit('inputsManual/change_psg_storeMutation', false)
            if (this.$store.state.manualHome.kid == null) {
                router.push('../manualStep/ManualHome');
            }

            this.$store.commit('configurations/MANU_configuration', true);
            this.$store.commit('configurations/change_elevatorMotor_Manual_storeMutation', true);
            this.$store.dispatch('inputsManual/set_inputsManual_storeAction');
        },

        methods: {
            ValueDecimalSeparator(value) {
                if (value != null) {
                    const localDecimal = { value: value, country: this.$store.state.configurations.language, }
                    return this.$get_decimalValueToLocaleString(localDecimal);
                }
                return value;
            },
            SM500() {

            },
            change_Selected_SM250_TS280(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('inputsManual/change_SM250_TS280_storeAction', value);
            },

            change_Selected_atElementOf_motorIpSelection(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('inputsManual/change_motorIpSelected_storeAction', value);
            },
            change_Selected_atElementOf_motorType(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('inputsManual/change_motorType_storeAction', value);
            },
            change_Selected_atElementOf_motorSize(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('inputsManual/change_motorSize_storeAction', value);
            },
            change_Selected_atElementOf_motorPackage(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('inputsManual/change_motorPackage_storeAction', value);
            },
            change_Selected_atElementOf_motorZusatz(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('inputsManual/change_motorZusatz_storeAction', value);
            },
            change_Selected_atElementOf_motorVoltage(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('inputsManual/change_motorVoltage_storeAction', value);
            },
            change_Selected_atElementOf_motorRatedSpeed(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('inputsManual/change_motorRatedSpeedSelected_storeAction', value);
            },
            change_Selected_atElementOf_certification(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('inputsManual/change_certification_storeAction', value);
            },
            change_Selected_atElementOf_preference(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('inputsManual/change_preference_storeAction', value);
            },
            change_Selected_atElementOf_temperatureMonitoring(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('inputsManual/change_temperatureMonitoring_storeAction', value);
            },
            change_Selected_atElementOf_forcedVentilation(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('inputsManual/change_forcedVentilation_storeAction', value);
            },
            showModalInputSelection() {
                this.$store.dispatch('inputsManual/change_showInputSelectionModal_storeAction', { value: true, component: 'motor' });
            },
            furtherToDriveTechnologies() {
                this.$store.dispatch('inputsManual/checkIf_inputsManual_areValid_storeAction');
            },
            furtherToManualHome() {
                this.$store.dispatch('inputsManual/cancelManualMotorConfiguration_storeAction')
            },
        },
    }
</script>


<style>
    .my_inputCheckboxSelected {
        border: none !important;
        list-style: none;
        padding-top: 5px;
        padding-left: 0px;
        padding-right: 0px;
        padding-bottom: 0px;
        margin: 0;
    }

    .my_inputCheckbox2 {
        border: 1px solid #ced2d8;
        list-style: none;
        padding-top: 5px;
        padding-left: 0px;
        padding-right: 0px;
        padding-bottom: 0px;
        margin: 0;
    }

        .my_inputCheckbox2 li {
            padding: 3px;
            /*margin-bottom: 3px;*/
        }

    .my_inputCheckbox {
        border: 1px solid #ced2d8;
        list-style: none;
        padding-top: 5px;
        padding-left: 0px;
        padding-right: 0px;
        padding-bottom: 0px;
        margin: 0;
    }

        .my_inputCheckbox li {
            display: inline-block;
            padding: 3px;
            /*margin-bottom: 3px;*/
        }

            .my_inputCheckbox li:nth-child(odd) {
                margin-right: 10px;
                width: calc(50% - 10px);
            }

            .my_inputCheckbox li:nth-child(even) {
                margin-left: 10px;
                width: calc(50% - 10px);
            }
</style>
